class Pagination {
  /**
   * Constructor: Pagination Constructor.
   */
  constructor(options = {}) {
    // Context
    this._context = options.context || document;

    // Root
    this._root = this._context.querySelector('.wp-pagenavi');
    
    if (!this._root) {
      return;
    }
    
    // Elements
    this._prev  = this._root.querySelector('.pagination__prev');
    this._next  = this._root.querySelector('.pagination__next');
    this._first = this._root.querySelector('.pagination__page--first');
    this._last  = this._root.querySelector('.pagination__page--last');

    // Rebuild
    this.rebuild();
  }

  /**
   * Rebuild: Rebuild pagination's DOM
   */
  rebuild() {
    // Rebuild Prev
    if (this._prev) {
      // Add SVG
      this._prev.innerHTML = `<svg viewBox="0 0 25.1 44.2" width="7" height="10"><path d="M22.1,0c0.8,0,1.5,0.3,2.1,0.9c1.2,1.2,1.2,3.1,0,4.2l-17,17l17,17c1.2,1.2,1.2,3.1,0,4.2c-1.2,1.2-3.1,1.2-4.2,0L0.9,24.2c-1.2-1.2-1.2-3.1,0-4.2L20,0.9C20.6,0.3,21.3,0,22.1,0z"/></svg>`;
      
      // Swap with First
      if (this._first) {
        this._root.insertBefore(this._prev, this._first);
      }
    }

    // Rebuild Next
    if (this._next) {
      // Add SVG
      this._next.innerHTML = `<svg viewBox="0 0 25.1 44.2" width="7" height="10"><path d="M3,44.2c-0.8,0-1.5-0.3-2.1-0.9c-1.2-1.2-1.2-3.1,0-4.2l17-17l-17-17c-1.2-1.2-1.2-3.1,0-4.2C2-0.3,4-0.3,5.1,0.9L24.2,20c1.2,1.2,1.2,3.1,0,4.2L5.1,43.3C4.5,43.9,3.8,44.2,3,44.2z"/></svg>`;

      // Swap with Last
      if (this._last) {
        this._root.insertBefore(this._last, this._next);
      }
    }

    // Rebuild Document Title
    document.title = document.title.replace(/Page[\s\d]+of[\s\d-_.]+/, '');
  }
}

export default Pagination;


// WEBPACK FOOTER //
// ./src/js/components/pagination.js